import HoursInput from './hours-input';
export * from './hours-input';

export default HoursInput;
